import { getCustomAccessToken } from "../authService";

// Returns the current access token for API requests. Replaces the old
// Okta tokenManager-based lookup — there's no Okta session to read from
// anymore, so this reads straight from the custom-auth token in
// sessionStorage
export const accessToken = async (): Promise<{ accessToken: string }> => {
  const token = getCustomAccessToken();
  if (!token) {
    throw new Error("Token not found");
  }
  return { accessToken: token };
};
